export const inIframe = () => window.top !== window.self;

export const navigateFullPage = (url: string): void => {
  try {
    if (inIframe() && window.top) {
      window.top.location.href = url;
      return;
    }
  } catch {
    console.warn("Top navigation blocked — falling through");
  }
  window.location.assign(url);
};
